import { render, staticRenderFns } from "./InformacionBancaria.vue?vue&type=template&id=5016e700&scoped=true"
import script from "./InformacionBancaria.vue?vue&type=script&lang=js"
export * from "./InformacionBancaria.vue?vue&type=script&lang=js"
import style0 from "./InformacionBancaria.vue?vue&type=style&index=0&id=5016e700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016e700",
  null
  
)

export default component.exports